import { render, staticRenderFns } from "./albumsDetail.vue?vue&type=template&id=8ef3449a&scoped=true&"
import script from "./albumsDetail.vue?vue&type=script&lang=js&"
export * from "./albumsDetail.vue?vue&type=script&lang=js&"
import style0 from "./albumsDetail.vue?vue&type=style&index=0&id=8ef3449a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef3449a",
  null
  
)

export default component.exports